<template>
  <div style="margin-top: -36px;overflow: hidden;">
    <Loading></Loading>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped></style>
